import React, { useState, useEffect } from 'react';

const webDesignTestimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication completely reimagined our brand presence. The intuitive UI/UX design and responsive storytelling increased our visitor time-on-site by 140% and generated a massive surge in qualified inbound leads.',
    author: 'Harrison Blake',
    designation: 'Managing Director, Horizon Luxe Global',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 2,
    quote:
      'Our previous website was outdated and failed to communicate our value. Their design team delivered a breathtaking, modern website that our clients constantly compliment. The sleek animations and mobile experience are world-class.',
    author: 'Elena Rostova',
    designation: 'Creative Director, Vanguard Studios',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 3,
    quote:
      'From interactive wireframing in Figma to pixel-perfect delivery, the web design team was exceptionally communicative and proactive. They didn’t just design a website; they elevated our entire brand identity.',
    author: 'Tariq Mansoor',
    designation: 'Founder & CEO, Apex Cloud Tech',
    avatar: '/assets/images/team_member_3.png'
  },
  {
    id: 4,
    quote:
      'Working with Experts Communication was an absolute game-changer. The conversion-focused design architecture doubled our consultation bookings within the first 60 days of launch. Highly recommended!',
    author: 'Sophia Chen',
    designation: 'Head of Growth, Amore Retail Group',
    avatar: '/assets/images/hr-manager.jpg'
  }
];

function WebDesignTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide smoothly every 4.5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % webDesignTestimonialsData.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const currentTestimonial = webDesignTestimonialsData[currentIndex];

  return (
    <section className="ecom-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What clients say about our web design!
          </span>

          <h2 className="bpo-testimonial-title">
            Designing Digital Experiences That <span className="text-red">Inspire & Convert</span>
          </h2>

          <p className="bpo-testimonial-desc">
            Discover authentic feedback and success stories from startup founders, business owners, and global brands whose online identity was transformed by Experts Communication’s web design team.
          </p>

          {/* Testimonial Card */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                "{currentTestimonial.quote}"
              </p>

              {/* Client Info & Quotation Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleDiscussClick}>
            Let's Discuss Your Project
          </button>
        </div>

        {/* Right Column: 5-Star Reviews Showcase Graphic */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star Web Design Reviews Customer Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDesignTestimonialsSlider;
